import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class LockoutService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    lockedUsers: any = null;

    GetLocked() {
        return this.http.get('/api/Lockout/').toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    Unlock(id) {
        return this.http.get('/api/Lockout/' + id).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }
    
    GetLockedUsers(reset) {
        var promise = new Promise((resolve, reject) => {
            if (this.lockedUsers === null || reset) {
                this.GetLocked().then((response) => {
                    if (response.success) {
                        this.lockedUsers = response.data;
                        resolve(this.lockedUsers);
                    } else {
                        this.flashService.Error(response.data.message, false);
                        reject();
                    }
                });
            } else {
                resolve(this.lockedUsers);
            }
        });
        return promise;
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
